// extracted by mini-css-extract-plugin
export var bg = "TopNews-module--bg--xeE1f";
export var container = "TopNews-module--container--Vm6wh";
export var title = "TopNews-module--title--KfuWl default-module--font-bold--5oEvQ";
export var list = "TopNews-module--list--AyXiT";
export var article = "TopNews-module--article--onlUt";
export var date = "TopNews-module--date--Nfp6w";
export var articleTitle = "TopNews-module--article-title--5iu2r";